// client/extensions/transformers/json-object.ts
import { Transformer } from "./Transformer.js";
var jsonObjectTransformer = new Transformer({
  type: "json-object",
  toContent: (value, extensions) => {
    if (typeof value === "string")
      throw new Error("cannot use string input with json-object transformer");
    return value;
  },
  toValue: (content) => content
});
export {
  jsonObjectTransformer
};
